module.exports = __webpack_public_path__ + "static/media/generatefile.341e1105.svg";